import { render } from "./Welcome.vue?vue&type=template&id=35cb6308&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=35cb6308&scoped=true&lang=css"

import exportComponent from "/app/vendor/quizwhiz-legacy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cb6308"]])

export default __exports__